(function(){
  function money(cents){
    if(cents === null || cents === undefined) return '';
    return '$' + (cents / 100).toFixed(2);
  }

  /* Struxa: this page quoted straight retail, so a shared build of 12 struts
     showed $816.00 when checkout would charge $734.40 - the shared link made
     Struxa look dearer than it is. Same rule as everywhere else: Shopify
     applies ONE automatic discount, the best one, and Elite is the single tier
     where bulk stacks (see "Elite Bulk Discount - 10+ Gas Struts"). Reads the
     globals layout/theme.liquid emits. */
  function tradePct(){ return (window.SX_TRADE && +window.SX_TRADE.pct) || 0; }
  function isElite(){ return !!(window.SX_TRADE && window.SX_TRADE.elite); }
  function bulkQty(){ return (window.SX_BULK && +window.SX_BULK.qty) || 10; }
  function bulkPct(){ return (window.SX_BULK && +window.SX_BULK.percent) || 10; }

  /* The Shopify minimum counts items across the whole order, so the threshold
     is the build's total quantity, not any one line. */
  function discountFor(totalQty){
    var trade = tradePct();
    var atBulk = totalQty >= bulkQty();
    if (atBulk && isElite()) return { pct: trade + 5, why: 'Elite bulk discount' };
    var bulk = atBulk ? bulkPct() : 0;
    if (trade >= bulk) return { pct: trade, why: trade ? 'trade discount' : '' };
    return { pct: bulk, why: bulkQty() + '+ bulk discount' };
  }

  var PLACEHOLDER_SVG = 'data:image/svg+xml;utf8,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="%238a8a86" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>'
  );

  function render(){
    var root = document.getElementById('sbRoot');
    var empty = document.getElementById('sbEmpty');
    if(!root) return;

    var items = (window.StruxaShare && window.StruxaShare.decodeItemsFromUrl) ? window.StruxaShare.decodeItemsFromUrl() : null;
    if(!items){
      root.style.display = 'none';
      /* /pages/shared-build?code=... is the editable single-build mode, drawn by
         assets/shared-build-editor.js. Without this the shared-cart renderer got
         there first and told the customer the link was invalid. */
      if(new URLSearchParams(window.location.search).get('code')) return;
      if(empty) empty.style.display = 'block';
      return;
    }

    var list = document.getElementById('sbList');
    var totalRow = document.getElementById('sbTotal');

    function totalQty(){
      return items.reduce(function(n, item){ return n + (item.quantity || 0); }, 0);
    }

    function updateTotal(){
      var totalKnown = true;
      var totalCents = 0;
      items.forEach(function(item){
        if(typeof item.price === 'number'){
          totalCents += item.price * item.quantity;
        } else {
          totalKnown = false;
        }
      });
      if(!totalRow) return;
      if(!totalKnown){
        totalRow.textContent = 'Final pricing is confirmed at checkout.';
        return;
      }
      var d = discountFor(totalQty());
      if(d.pct > 0){
        var after = Math.round(totalCents * (1 - d.pct / 100));
        totalRow.innerHTML =
          '<s style="color:#1c1e22;">' + money(totalCents) + '</s> ' +
          '<strong>Estimated total: ' + money(after) + '</strong> (excl. shipping)' +
          '<br><span style="color:#1c7a1c;font-weight:700;">' + d.pct + '% ' + d.why + ' applied at checkout</span>';
      } else {
        totalRow.textContent = 'Estimated total: ' + money(totalCents) + ' (excl. shipping)';
      }
      /* Line prices depend on the whole build's quantity, so they have to be
         redrawn whenever any row's quantity changes. */
      items.forEach(function(item){ if(item.__redraw) item.__redraw(); });
    }

    items.forEach(function(item, idx){
      var row = document.createElement('div');
      row.className = 'sb-row';

      var imgWrap = document.createElement('div');
      imgWrap.className = 'sb-row-img';
      var img = document.createElement('img');
      var imgSrc = item.image && window.StruxaShare && window.StruxaShare.sizedImage
        ? window.StruxaShare.sizedImage(item.image, 160)
        : (item.image || PLACEHOLDER_SVG);
      img.src = imgSrc;
      img.alt = item.title || '';
      img.loading = 'lazy';
      // If the resized/CDN image ever fails to load, fall back to a simple
      // placeholder icon instead of leaving a blank/broken box.
      img.addEventListener('error', function(){
        if(img.src !== PLACEHOLDER_SVG) img.src = PLACEHOLDER_SVG;
      });
      imgWrap.appendChild(img);
      row.appendChild(imgWrap);

      var body = document.createElement('div');
      body.className = 'sb-row-body';
      var title = document.createElement('div');
      title.className = 'sb-row-title';
      title.textContent = item.title || 'Item';
      body.appendChild(title);

      var propsToShow = [];
      if(item.properties){
        Object.keys(item.properties).forEach(function(k){
          if(k.charAt(0) === '_') return;
          if(item.properties[k] === '' || item.properties[k] == null) return;
          propsToShow.push(k + ': ' + item.properties[k]);
        });
      }
      if(propsToShow.length){
        var meta = document.createElement('div');
        meta.className = 'sb-row-meta';
        meta.textContent = propsToShow.join(' · ');
        body.appendChild(meta);
      }

      var qtyWrap = document.createElement('div');
      qtyWrap.className = 'sb-row-qty';
      var qtyLabel = document.createElement('span');
      qtyLabel.textContent = 'Qty ';
      qtyWrap.appendChild(qtyLabel);
      var qtyInput = document.createElement('input');
      qtyInput.type = 'number';
      qtyInput.min = '1';
      qtyInput.value = item.quantity;
      qtyInput.className = 'sb-row-qty-input';
      qtyWrap.appendChild(qtyInput);
      body.appendChild(qtyWrap);

      row.appendChild(body);

      var priceEl = document.createElement('div');
      priceEl.className = 'sb-row-price';
      function renderPrice(){
        if(typeof item.price !== 'number'){ priceEl.textContent = ''; return; }
        var gross = item.price * item.quantity;
        var d = discountFor(totalQty());
        if(d.pct > 0){
          priceEl.innerHTML = '<s style="color:#1c1e22;font-weight:400;">' + money(gross) + '</s><br>' +
                              money(Math.round(gross * (1 - d.pct / 100)));
        } else {
          priceEl.textContent = money(gross);
        }
      }
      item.__redraw = renderPrice;
      renderPrice();
      row.appendChild(priceEl);

      qtyInput.addEventListener('change', function(){
        var v = parseInt(qtyInput.value, 10);
        if(!v || v < 1) v = 1;
        qtyInput.value = v;
        item.quantity = v;
        renderPrice();
        updateTotal();
      });

      list.appendChild(row);
    });

    updateTotal();

    var addBtn = document.getElementById('sbAddAll');
    var msgEl = document.getElementById('sbMsg');
    if(addBtn){
      addBtn.textContent = items.length === 1 ? 'Add to Cart' : 'Add All to Cart';
      addBtn.addEventListener('click', function(){
        if(!window.StruxaShare) return;
        var orig = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
        window.StruxaShare.addAllToCart(items, function(err){
          addBtn.disabled = false;
          addBtn.textContent = orig;
          if(err){
            msgEl.style.display = 'block';
            msgEl.style.color = '#c0392b';
            msgEl.textContent = err.message || 'Something went wrong adding these items - some may be sold out.';
          } else {
            window.location.href = '/cart';
          }
        });
      });
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();
